import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import AutoSuggest from "components/Forms/Elements/AutoSuggest";
import { hasProperty } from "helpers/object";
import { getAllUsers } from "store/actions/userAction";
import Translate from "helpers/Translate";

const Filters = ({ handleOnFilter, selectedClient }) => {
  const dispatch = useDispatch();
  const users = useSelector(state => state.user.getAllUsers);
  const [filteredUser, setFilteredUser] = useState("");

  // Fetch all users
  useEffect(() => {
    if (selectedClient) {
      dispatch(
        getAllUsers({
          clientId: selectedClient.id
        })
      );
    }
  }, [selectedClient]);

  return (
    <div className="filters">
      <div className="title">
        <i className="fas fa-filter"></i> {Translate({ id: "filter" })} :
      </div>
      <div className="filter-a">
        <label htmlFor="document-type">
          {Translate({ id: "search_user" })}{" "}
        </label>
        <AutoSuggest
          id="doctype"
          fieldValue={filteredUser ? filteredUser.fullname : ""}
          data={hasProperty(() => users.data, [])}
          keyword={value => {
            dispatch(
              getAllUsers({
                clientId: selectedClient.id,
                name: value
              })
            );
          }}
          displayItemInList="fullname"
          onSelect={selectedItem => setFilteredUser(selectedItem)}
          onClose={() => {
            dispatch(
              getAllUsers({
                clientId: selectedClient.id
              })
            );
            setFilteredUser("");
          }}
        />
      </div>
      <div className="filter-c">
        <label htmlFor="name">&nbsp;</label>
        <input
          type="button"
          value={Translate({ id: "filter" })}
          className="btn btn-primary btn-sm"
          onClick={() => handleOnFilter(filteredUser)}
        />
      </div>
    </div>
  );
};

Filters.propTypes = {
  handleOnFilter: PropTypes.func.isRequired,
  selectedClient: PropTypes.object.isRequired
};

export default Filters;
